// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2ZD5I","buttons":"RemoveExpirationActionButtons_buttons__2Iy6o"};